
  <div class="jobber-timeline-item">
    <div class="jobber-timeline-cricle z-index-0">
      <i class="far fa-circle"></i>
    </div>
    <div class="jobber-timeline-info">
      <div class="dashboard-timeline-info d-flex flex-column">
        <div class="col-lg-12">
          <span class="jobber-timeline-time" *ngIf="experience.currentJob">{{experience.fromDate | date: "dd-MM-yyyy"}} to Current Date</span>
          <span class="jobber-timeline-time" *ngIf="!experience.currentJob">{{experience.fromDate | date: "dd-MM-yyyy"}} to {{experience.toDate | date: "dd-MM-yyyy"}}</span>
          <h6 class="mb-2">{{experience.title}}</h6>
          <span>- {{experience.company}}</span>
          <p class="mt-2">{{experience.description}}</p>
        </div>
        <div class="col-lg-12">
          <app-attachments-preview *ngIf="!showEditForm" [attachments]="experience.attachments"></app-attachments-preview>
        </div>
        <div class="col-lg-12" *ngIf="readonly == false">
          <div class="dashboard-timeline-edit">
            <ul class="list-unstyled d-flex">
              <li><a class="text-right" data-toggle="collapse" [routerLink]="" (click)="editExperience()" role="button" aria-expanded="false"
                aria-controls="dateposted"> <i class="fas fa-pencil-alt text-info mr-2"></i> </a></li>
              <li><a [routerLink]="" (click)="deleteExperience()"><i class="far fa-trash-alt text-danger"></i></a></li>
            </ul>
          </div>
        </div>
      </div>
      <div *ngIf="showEditForm">
        <app-experience-form [experience]="experience" [index]="index" (saved)="experienceSaved()"></app-experience-form> 
      </div>
    </div>
  </div>
